import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import { useAuthStore } from "@companion-core/shared/app/Store/authStore";

export const useWebNavigationHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { authenticated } = useAuthStore((state) => ({ authenticated: state.authenticated }));
  const { config } = useConfigStore((state) => ({
    config: state.config,
  }));
  const options = useMemo(() => config?.options, [config]);
  const canGoBack = useMemo(() => location.state?.canGoBack ?? false, [location]);
  const { logged: homeRouteLogged, unlogged: homeRouteUnlogged } = useMemo(
    () => options?.homeRoutes["web"],
    [options],
  );
  const homeRoute = useMemo(
    () => `/${authenticated ? homeRouteLogged : homeRouteUnlogged}`,
    [authenticated, homeRouteLogged, homeRouteUnlogged],
  );
  const navigateBackward = useCallback(
    (path?: string) => (canGoBack ? navigate(-1) : navigate(path ?? homeRoute)),
    [canGoBack],
  );

  return { navigateBackward };
};
